import * as React from 'react';
import { Field } from 'redux-form';

import { FormEditor } from '@inqool/uas-web-core/es/components/controls/Editor';

import * as T from '@components/form/Editor/_editorTypes';

const Editor: React.SFC<T.OutterProps & T.InnerProps> = props => {
  return <FormEditor {...props} />;
};

export default Editor;

export class EditorField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Editor/Editor.tsx